import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigateWithParams } from "../../../hooks/useNavigateWithParams";

import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import FAIL from "../../../assets/images/FAIL.svg";
import Text from "../../atoms/Text/Text";
import Title from "../../atoms/Title/Title";
import Footer from "../../templates/Footer/Footer";
import Header from "../../templates/Header/Header";
import StyledButton from "../../atoms/StyledButton/StyledButton";
import { AppRoutes } from "../../../routes/AppRoutes";

const Fail = () => {
  const navigate = useNavigateWithParams();
  const { t } = useTranslation();

  return (
    <>
      <Header headerStep={{ context: "new_subscription", step: 4, totalSteps: 3 }}title={t("subscription:FAIL_PAGE.TITLE")} />
      <Box className="Fail">
        <Box className="content">
          <LogoSvg className="Logos" src={FAIL} />
          <Title
            variant="h1"
            children={t("subscription:FAIL_PAGE.TITLE") + " !"}
          />
          <Text children={t("subscription:FAIL_PAGE.TEXT")} />
        </Box>
      </Box>
      <Footer headerStep={{ context: "new_subscription", step: 4, totalSteps: 3 }}>
        <StyledButton children={t("subscription:FAIL_PAGE.BUTTON")} onClick={() => {navigate(AppRoutes.OPTIONS)}} />
      </Footer>
    </>
  );
};

export default Fail;
